var map = {
	"./1LogoLeelee.png": "c297",
	"./FondoLetras.png": "d0fe",
	"./Game1MP.png": "ff29",
	"./Game2MP.png": "207a",
	"./ICONO1.png": "17c5",
	"./ICONO2.png": "b814",
	"./Letra.png": "a5b3",
	"./activity1.png": "f51d",
	"./activity2.png": "6d90",
	"./activity3.png": "4863",
	"./altavoz.svg": "108f",
	"./aula.png": "d851",
	"./background-difuminado.jpg": "a215",
	"./barajar.svg": "9e267",
	"./barrier.png": "8341",
	"./base-para-bingo-silabas-directas.png": "b8bd",
	"./bingo-base-silabas-inversas.png": "e6c5",
	"./bingo-base.png": "670e",
	"./bingo-canto-silabas-inversas.png": "0f6c",
	"./bingo-canto.png": "450b",
	"./bingo-instrucciones.png": "dc89",
	"./bingo-tarjetas-silabas-inversas.png": "dad3",
	"./bingo-tarjetas.png": "e0c1",
	"./buscar.svg": "4e85",
	"./calendario-1-2grade.png": "6aab",
	"./calendario-3-5grade.png": "45ef",
	"./calendario-Kinder.png": "1d1c",
	"./calendario-Pre-Kinder.png": "9daf",
	"./cartas-para-cantar-silabas-directas.png": "9da7",
	"./cartas-silabas-directas.png": "ecdc",
	"./cartilla.svg": "2891",
	"./cartillas-silabas-directas.png": "adc1",
	"./cartillas-silabas-inversas-directas.png": "5528",
	"./cartillas-silabas-inversas.png": "3f46",
	"./cartillas-silabas-trabadas.png": "62d0",
	"./certificadoM1.png": "6198",
	"./certificadoM2.png": "e736",
	"./certificadoM3.png": "ce83",
	"./certificadoM4.png": "0d67",
	"./certificadoM5.png": "4a20",
	"./certificadoM6.png": "9e26",
	"./certificadoM7.png": "b256",
	"./change-password.gif": "d1c4",
	"./clase.svg": "1d92",
	"./clase2.png": "b2ce",
	"./classroom-disabled.gif": "682d",
	"./classroom-enabled.jpg": "2f59",
	"./code.png": "c940",
	"./cols1-FL.png": "e2c9",
	"./cols1-LF.png": "9456",
	"./cols2.png": "30ed",
	"./comando-de-voz.svg": "e626",
	"./default-class.png": "5d6c",
	"./dibujoyfigura.png": "ca1d",
	"./educacion.svg": "3719",
	"./enabled.gif": "fadb",
	"./fondo-misiones.gif": "5160",
	"./fondo-web-4.jpg": "eeae",
	"./groups.png": "56f3",
	"./guia-estudio-k2.png": "d179",
	"./imagen.svg": "dc5b",
	"./juego1.png": "9fd2",
	"./juego2.png": "0fe8",
	"./login.png": "9ed2",
	"./logo-te.png": "db64",
	"./logo_QR.png": "2ece",
	"./menu-lateral.png": "6ffd",
	"./missions.jpg": "61cc",
	"./multiplayer_gamers.jpg": "f6e7",
	"./multiplayer_intro.jpg": "a6cd",
	"./otrosrecursos1.png": "2b8c",
	"./otrosrecursos2.png": "3579",
	"./palabras2silabas.fw.png": "5b0a",
	"./palabras2silabas.png": "834e",
	"./palabras2silabasdibujo.png": "d1c8d",
	"./palabras3silabas.png": "bef8",
	"./palabrassilabastrabadas.png": "7d14",
	"./phonetic-articulation-cards.png": "e171",
	"./sad_face.png": "1e7a",
	"./school.png": "54e1",
	"./sombrero-de-graduacion.svg": "c915",
	"./statistics.svg": "0778",
	"./student-start.png": "ea2a",
	"./students.png": "824e",
	"./table.svg": "3d59",
	"./te-mision1.jpg": "f51f",
	"./te-mision2.jpg": "35cb",
	"./te-mision3.jpg": "b466",
	"./te-mision4.jpg": "08bb",
	"./te-mision5.jpg": "3256",
	"./te-mision6.jpg": "d153",
	"./te-mision7.png": "8b8d",
	"./teacher-explain.jpg": "1487",
	"./teacher-home-fondo.svg": "7c78",
	"./teacher-home.svg": "03e5",
	"./teaching-tools.svg": "f803",
	"./video-student.png": "bf47",
	"./video-teacher.png": "fd88",
	"./wait.png": "1938"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0683";